import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Link } from '@siemens/element-ng/link';
import { FOOTER_CONFIG } from '@tran-monorepo/frontend/core';

@Component({
    selector: 'tran-ui-footer',
    imports: [TranslatePipe],
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
    public readonly copyright: string = FOOTER_CONFIG.copyright;
    public readonly poweredBy: string = FOOTER_CONFIG.poweredBy;
    public readonly currentYear: number = new Date().getFullYear();
    public readonly poweredByHref: string = FOOTER_CONFIG.poweredByHref;
    public readonly links: Link[] = FOOTER_CONFIG.links;
}
